import http from '../utils/http';

export function GetAppMessageDetail(data = {}) {
  const url = {
    dev:
      'https://teacherapi-test.zmlearn.com/v1/teacherApp/app/message/official-message-detail',
    fat:
      'https://teacherapi-test.zmlearn.com/v1/teacherApp/app/message/official-message-detail',
    uat:
      'https://teacherapi.uat.zmops.cc/v1/teacherApp/app/message/official-message-detail',
    prod:
      'https://teacherapi.zmlearn.com/v1/teacherApp/app/message/official-message-detail',
  };
  return http.post(url[process.env.VUE_APP_RUN_ENV], data);
}

export function GetClientMessageDetail(data, token) {
  const url = {
    dev: `https://test-chat-gateway.zmlearn.com/zmc-index/api/msg/center/tea/getMessageView?access_token=${token}`,
    fat: `https://test-chat-gateway.zmlearn.com/zmc-index/api/msg/center/tea/getMessageView?access_token=${token}`,
    uat: `https://chat.uat.zmops.cc/gateway/zmc-index/api/msg/center/tea/getMessageView?access_token=${token}`,
    prod: `https://chat.zmlearn.com/gateway/zmc-index/api/msg/center/tea/getMessageView?access_token=${token}`,
  };
  return http.post(url[process.env.VUE_APP_RUN_ENV], data);
}